import { render, staticRenderFns } from "./MedRecordUpdate.vue?vue&type=template&id=d700a564"
import script from "./MedRecordUpdate.vue?vue&type=script&lang=js"
export * from "./MedRecordUpdate.vue?vue&type=script&lang=js"
import style0 from "./MedRecordUpdate.vue?vue&type=style&index=0&id=d700a564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports